"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexToRGBA = exports.randomColor = exports.urlEncodeColour = void 0;

var urlEncodeColour = function urlEncodeColour(colour) {
  return colour.replace('#', '%23');
};

exports.urlEncodeColour = urlEncodeColour;

var randomColor = function randomColor() {
  return '#' + Math.floor(Math.random() * 16777215).toString(16);
};

exports.randomColor = randomColor;

var hexToRGBA = function hexToRGBA(hex, alpha) {
  var codes = [hex.slice(1, 3), hex.slice(3, 5), hex.slice(5, 8)];
  return "rgba(".concat(parseInt('0x' + codes[0]), ", ").concat(parseInt('0x' + codes[1]), ", ").concat(parseInt('0x' + codes[2]), ", ").concat(alpha, ")");
};

exports.hexToRGBA = hexToRGBA;